module.exports = __webpack_public_path__ + "img/1532581278.766a1e41.jpg";